import { render } from "./AudioCoursewareCard.vue?vue&type=template&id=9331b9c4&scoped=true"
import script from "./AudioCoursewareCard.vue?vue&type=script&lang=ts"
export * from "./AudioCoursewareCard.vue?vue&type=script&lang=ts"

import "./AudioCoursewareCard.vue?vue&type=style&index=0&id=9331b9c4&scoped=true&lang=css"
import "./AudioCoursewareCard.vue?vue&type=style&index=1&id=9331b9c4&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-9331b9c4"

export default script